import { CmsMedia } from '@/service';

/**
 * @class @name Content
 * @description Exposes menu store module
 */
export default class Media {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {
			mediaList: []
		};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {
			/**
			 * @name setMediaList
			 * @description used to set content on store
			 * @param {Object} state
			 * @param {Object} data
			 */
			setMediaList: (state, data) => (state.mediaList = data)
		};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadMediaList
			 * @param {function} commit
			 */
			async loadMediaList({ commit, rootState }, tagNameUnique) {
				const domain = rootState.CmsSite.site.name || 'default';
				let { data } = await CmsMedia.list({ where: { 'tag.name_unique': tagNameUnique }, order: { property: 'uploaded', direction: 'desc' } }, domain);
				commit('setMediaList', data.data);
			}
		};
	}
}
